import { Grid, Space } from "../Layout";
import { Texts, Title, Media, Button, Link } from "../Object";
import { NewsList } from "../Post";

const News = (props) => {
  const gridProps = {
    list: {
      gap: ['64px', '24px'],
      layout: ['repeat(3, 1fr)', '100%'],
      size: '100%',
    }
  }
  
  return (
    <>
      <Space size={['120px 0 100px', '80px 0 72px']}>
        <div className="l-row">
          <Title slug="news"></Title>
          <Space size={["100px 0 80px", "64px 0 48px"]}>
            <Grid {...gridProps.list}>
              <NewsList></NewsList>
            </Grid>
          </Space>
          <Button type="center" slug="news" link="/posts/"></Button>
        </div>
      </Space>
    </>
  );
};

export default News;
